<template>
  <div class="main-container">
    <div v-if="!isFetching" class="layout-container">
      <Default v-if="layout == 'Default'" />
      <Empty v-else-if="layout == 'Empty'" />
    </div>
    <ui-loader v-else :type="1" :display="isFetching" />
  </div>
</template>

<script setup lang="ts">
  import Default from '@/layouts/DefaultLayout.vue'
  import Empty from '@/layouts/EmptyLayout.vue'
  import { GetLanguageData } from '@/utils-ts'
  import { computed, onBeforeMount, ref } from 'vue'
  import { useRoute, useRouter } from 'vue-router'

  const route = useRoute()
  const router = useRouter()

  const isFetching = ref<boolean>(true)

  const layout = computed(() => {
    if (route.meta.isDefault === false) {
      return 'Empty'
    }
    return 'Default'
  })

  onBeforeMount(async () => {
    await router.isReady()
    await GetLanguageData()
    isFetching.value = false
  })
</script>
<style lang="scss">
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  html {
    font-family: $font-family;
    font-size: 16px;
    min-height: 100vh;
    background-color: #f5f5f5;
  }
  .main-loader {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
